// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt-20{
    margin-top: 5px;
    margin-bottom: 5px !important;

}
.mt-9{
    margin-top: 9px;
    margin-bottom: 9px !important;
}
.mt-10{
    margin-top: 10px;
    margin-bottom: 10px !important;
}
.lh-18{
    line-height: 18px;
}
.table td, .table th {
    padding: 3px !important;
}
.table td, .table th {
    border: 1px solid black !important;
}
.width-160{
    width: 160px;
}
td > input {
    padding: 3px;
    padding-left: 4px;
}
.font-wt-700{
font-size: 16px;
}
select{
    font-size: 16px;
    height: inherit;
    padding: 2px;
}
.date{
    font-size: 16px !important;
    height: inherit !important;
    padding: 2px !important;
    padding-left: 4px !important;
}

.btn{
    font-size: 16px;
    padding: 5px;
}
:host ::ng-deep .completer-input {
  font-size: 16px !important;
  height: inherit !important;
  padding: 2px !important;
  padding-left: 4px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/offer/newoffering/newoffering.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,6BAA6B;;AAEjC;AACA;IACI,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;AACA,eAAe;AACf;AACA;IACI,eAAe;IACf,eAAe;IACf,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B","sourcesContent":[".mt-20{\r\n    margin-top: 5px;\r\n    margin-bottom: 5px !important;\r\n\r\n}\r\n.mt-9{\r\n    margin-top: 9px;\r\n    margin-bottom: 9px !important;\r\n}\r\n.mt-10{\r\n    margin-top: 10px;\r\n    margin-bottom: 10px !important;\r\n}\r\n.lh-18{\r\n    line-height: 18px;\r\n}\r\n.table td, .table th {\r\n    padding: 3px !important;\r\n}\r\n.table td, .table th {\r\n    border: 1px solid black !important;\r\n}\r\n.width-160{\r\n    width: 160px;\r\n}\r\ntd > input {\r\n    padding: 3px;\r\n    padding-left: 4px;\r\n}\r\n.font-wt-700{\r\nfont-size: 16px;\r\n}\r\nselect{\r\n    font-size: 16px;\r\n    height: inherit;\r\n    padding: 2px;\r\n}\r\n.date{\r\n    font-size: 16px !important;\r\n    height: inherit !important;\r\n    padding: 2px !important;\r\n    padding-left: 4px !important;\r\n}\r\n\r\n.btn{\r\n    font-size: 16px;\r\n    padding: 5px;\r\n}\r\n:host ::ng-deep .completer-input {\r\n  font-size: 16px !important;\r\n  height: inherit !important;\r\n  padding: 2px !important;\r\n  padding-left: 4px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
